import { render } from "./C_InWork.vue?vue&type=template&id=54050413"
import script from "./C_InWork.vue?vue&type=script&lang=js"
export * from "./C_InWork.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__